<template>
  <section class="by-the-numbers" id="by-the-numbers">
    <div class="container">
      <h2>{{ $t('byTheNumbers.title') }}</h2>
      <p class="subtitle">{{ $t('byTheNumbers.subtitle') }}</p>
      <div class="stats-grid">
        <div v-for="(stat, i) in $tm('byTheNumbers.stats')" :key="i" class="stat-card">
          <span class="stat-value">{{ stat.value }}</span>
          <span class="stat-label">{{ stat.label }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.by-the-numbers {
  padding: 80px 20px;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
  color: white;
  text-align: center;
}

.container {
  max-width: 1000px;
  margin: 0 auto;
}

h2 {
  font-size: 2.5rem;
  margin-bottom: 20px;
}

.subtitle {
  font-size: 1.2rem;
  max-width: 700px;
  margin: 0 auto 50px;
  opacity: 0.9;
  line-height: 1.6;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.stat-card {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  backdrop-filter: blur(4px);
  transition: transform 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
}

.stat-value {
  font-size: 3rem;
  font-weight: 800;
}

.stat-label {
  font-size: 1rem;
  opacity: 0.9;
  line-height: 1.4;
}

@media (max-width: 768px) {
  .by-the-numbers {
    padding: 40px 15px;
  }
  h2 {
    font-size: 1.8rem;
  }
  .stats-grid {
    grid-template-columns: 1fr;
  }
  .stat-value {
    font-size: 2.5rem;
  }
}
</style>
